module.exports = __webpack_public_path__ + "img/10-l.006c299a.png";